import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/organization`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchOrganizations = (payload) => apiHelper(API_URL, 'GET', payload);
export const createOrganization = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchOrganization = (organizationId) => apiHelper(`${API_URL}/${organizationId}`, 'GET');
export const modifyOrganization = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteOrganizationApi = (organizationId) => apiHelper(`${API_URL}/${organizationId}`, 'DELETE');
export const changeStatus = (organizationId) => apiHelper(`${API_URL}/change-status/${organizationId}`, 'POST');
export const fetchBusinessTypes = (payload) => apiHelper(`${process.env.REACT_APP_API_URL}/api/business-types`, 'GET', payload);
export const fetchOrganizationTypes = (payload) => apiHelper(`${process.env.REACT_APP_API_URL}/api/organization-types`, 'GET', payload);

